/**
 * NWL Theme — Vanilla JavaScript
 * Converted from React state logic
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================
     MOBILE MENU TOGGLE
     ============================================ */
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-close-btn');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Close mobile nav when clicking a link
  if (mobileNav) {
    mobileNav.querySelectorAll('.nav-link').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ============================================
     BACK TO TOP BUTTON
     ============================================ */
  const backToTop = document.querySelector('.back-to-top');

  if (backToTop) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 400) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    });

    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ============================================
     QUANTITY SELECTORS (Product Detail only)
     Cart quantity is handled via AJAX in cart-content.liquid
     ============================================ */
  document.querySelectorAll('.quantity-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    var decBtn = selector.querySelector('button:first-child');
    var incBtn = selector.querySelector('button:last-child');

    if (!input || !decBtn || !incBtn) return;

    decBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });

    incBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10);
      input.value = val + 1;
    });
  });

  /* ============================================
     PRODUCT DETAIL TABS
     ============================================ */
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabPanes = document.querySelectorAll('.tab-pane');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.getAttribute('data-tab');

      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      tabPanes.forEach(function (pane) {
        pane.style.display = pane.getAttribute('data-tab') === target ? 'block' : 'none';
      });
    });
  });

  /* ============================================
     PRODUCT IMAGE THUMBNAILS
     ============================================ */
  document.querySelectorAll('.thumbnail-gallery .thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const mainImg = thumb.closest('.product-gallery').querySelector('.main-image');
      if (mainImg) {
        mainImg.src = thumb.src.replace('width=200', 'width=800').replace('w=200', 'w=800');
      }
      thumb.closest('.thumbnail-gallery').querySelectorAll('.thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

});
